import type { MysteryRoomLocalRuntime } from './localRuntime';

export type MysteryRoomRuntimeControllerSnapshot = {
  runtime: MysteryRoomLocalRuntime;
  version: number;
  publishedAtMs: number;
};

type MysteryRoomRuntimeControllerMutateOptions = {
  publish?: boolean;
};

export class MysteryRoomRuntimeController {
  private runtime: MysteryRoomLocalRuntime;

  private snapshot: MysteryRoomRuntimeControllerSnapshot;

  private version = 0;

  private listeners = new Set<() => void>();

  constructor(initialRuntime: MysteryRoomLocalRuntime) {
    this.runtime = initialRuntime;
    this.snapshot = this.createSnapshot(0);
  }

  getRuntime = () => this.runtime;

  getSnapshot = () => this.snapshot;

  subscribe = (listener: () => void) => {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  };

  replace(runtime: MysteryRoomLocalRuntime, options: MysteryRoomRuntimeControllerMutateOptions = {}) {
    this.runtime = runtime;
    if (options.publish !== false) {
      this.publish();
    }
    return this.runtime;
  }

  mutate(
    updater: (runtime: MysteryRoomLocalRuntime) => MysteryRoomLocalRuntime,
    options: MysteryRoomRuntimeControllerMutateOptions = {},
  ) {
    this.runtime = updater(this.runtime);
    if (options.publish !== false) {
      this.publish();
    }
    return this.runtime;
  }

  publish() {
    this.version += 1;
    this.snapshot = this.createSnapshot(Date.now());
    this.listeners.forEach((listener) => listener());
    return this.snapshot;
  }

  private createSnapshot(publishedAtMs: number): MysteryRoomRuntimeControllerSnapshot {
    return {
      runtime: this.runtime,
      version: this.version,
      publishedAtMs,
    };
  }
}

export function createMysteryRoomRuntimeController(initialRuntime: MysteryRoomLocalRuntime) {
  return new MysteryRoomRuntimeController(initialRuntime);
}
